import Drawer from "./Drawer";

/**
 * A button to show/hide the drawer
 */
export default class DrawerHandle {
    /**
     * A button to show/hide the drawer
     *
     * @param {HTMLElement} element
     * @param {Drawer} drawer
     * @constructor
     */
    constructor(element, drawer) {
        if (!(drawer instanceof Drawer)) {
            throw new TypeError('Argument "drawer" must be an instance of "Drawer"');
        }
        const _click = this.click = this.click.bind(this);
        this._drawer = drawer;

        element.addEventListener('click', _click);
    }

    click(event) {
        event.preventDefault();
        this._drawer.toggle();
    }
}



// WEBPACK FOOTER //
// ./Resources/Private/JavaScripts/src/Ui/DrawerHandle.js